import { decode } from 'js-base64'
import { isClientSide } from './ssrUtils'

export const getScreenHeightLessHeader = (): string | undefined => {
    if (isClientSide) {
        const headerHeight = document.getElementById('header')?.clientHeight ?? 0
        return `calc(100vh - ${headerHeight}px - 4em)`
    }
}

export const getElementWidth = (element: string): number | undefined => {
    if (isClientSide) {
        const domElement = document.getElementById(element)
        if (domElement) {
            const computedElement = getComputedStyle(domElement)
            const paddingX = parseFloat(computedElement.paddingLeft) + parseFloat(computedElement.paddingRight)
            const borderX = parseFloat(computedElement.borderLeftWidth) + parseFloat(computedElement.borderRightWidth)
            return domElement.offsetWidth - paddingX - borderX
        }

        return 0
    }
}

export const getElementHeight = (element: string): number => {
    if (isClientSide) {
        const domElement = document.getElementById(element)

        if (domElement) {
            const computedElement = getComputedStyle(domElement)
            const paddingX = parseFloat(computedElement.paddingLeft) + parseFloat(computedElement.paddingRight)
            const borderX = parseFloat(computedElement.borderLeftWidth) + parseFloat(computedElement.borderRightWidth)
            return domElement.offsetHeight - paddingX - borderX
        }

        return 0
    }

    return 0
}

export const scrollToBottomElement = (element: string): void => {
    const creditsTableContainer = document.getElementById(element)

    if (creditsTableContainer) {
        creditsTableContainer.scrollTop = creditsTableContainer?.clientHeight
    }
}

export const isEllipsisActive = (e: HTMLElement): boolean => {
    return e?.scrollWidth > e?.clientWidth
}

export const resolveBase64Namespace = (value: string): string => {
    const decodedValue = decode(value)
    const isSvg = decodedValue.startsWith('<svg') || decodedValue.startsWith('<?xml')
    const namespace = isSvg ? 'data:image/svg+xml' : 'data:image/png'
    return namespace
}
